import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { usePostHog } from '@posthog/react'
import { sanitizeAnalyticsUrl } from '@/shared/lib/posthog/sanitizeAnalyticsUrl'

/** Pageviews SPA — complementa autocapture quando a rota muda. */
export function PosthogPageView() {
  const posthog = usePostHog()
  const { pathname, search } = useLocation()

  useEffect(() => {
    const href = `${window.location.origin}${pathname}${search}`
    posthog.capture('$pageview', { $current_url: sanitizeAnalyticsUrl(href) })
  }, [pathname, posthog, search])

  return null
}
